import React from 'react';

function DownArrowIcon2({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M2.58156 4.11035L1.40156 5.29035L8.00156 11.8904L14.6016 5.29035L13.4216 4.11035L8.00156 9.53035L2.58156 4.11035V4.11035Z'
				fill='#545454'
			></path>
		</svg>
	);
}

export default DownArrowIcon2;
